exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-btn{margin:5px;color:#ffffff}.toast-button-info{background-color:#2f96b4}.toast-button-success{background-color:#51a351}.toast-button-warning{background-color:#f89406}.toast-button-error{background-color:#bd362f}.toast-button-default{background-color:#599fd2}p{margin-bottom:0}\n", ""]);

// exports
